import Onboarding from 'lib/components/onboarding/onboarding'
export default Onboarding
